import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getMethod, postMethod } from "../../services/ApiCallMethods";

export const requestEmailChange = createAsyncThunk(
  "resend/requestEmailChange",
  async (payload, { rejectWithValue }) => {
    try {

      const response = await postMethod(
        `/api/request-email-change/${payload.userId}`,
        payload
      );

      const data = await response.json();

      if (data?.error) return rejectWithValue(data.error);

      return data;
    } catch (error) {
      return rejectWithValue(
        error?.message || "Failed to request email change"
      );
    }
  }
);

export const verifyEmailChange = createAsyncThunk(
  "resend/verifyEmailChange",
  async ({ userId, otp }, { rejectWithValue }) => {
    try {
      const response = await postMethod(`/api/verify-email-change/${userId}`, {
        otp,
      });
      const data = await response.json();

      if (data?.error) return rejectWithValue(data.error);

      return data;
    } catch (error) {
      return rejectWithValue(error?.message || "Failed to verify email change");
    }
  }
);

export const resendInvite = createAsyncThunk(
  "resend/resendInvite",
  async (userId, { rejectWithValue }) => {
    try {
      const response = await postMethod(`/api/${userId}/resend-invite`);
      const data = await response.json();

      if (data?.error) return rejectWithValue(data.error);
      if (!data?.setupURL || !data?.email) {
        return rejectWithValue("Invalid response from server.");
      }

      return {
        setupUrl: data.setupURL,
        email: data.email,
      };
    } catch (error) {
      return rejectWithValue(error?.message || "Failed to resend invite");
    }
  }
);
export const getCopyUrl = createAsyncThunk(
  "resend/getCopyUrl",
  async (userId, { rejectWithValue }) => {
    try {
      const response = await getMethod(`/api/users/${userId}/invite-link`);
      const data = await response.json();

      if (data?.error) return rejectWithValue(data.error);
      if (!data?.inviteLink) {
        return rejectWithValue("Invite link not found.");
      }

      return data.inviteLink;
    } catch (error) {
      return rejectWithValue(error?.message || "Failed to fetch invite link");
    }
  }
);



const resendInviteSlice = createSlice({
  name: "resend",
  initialState: {
    getLoading: false,
    error: null,
    setupUrl: null,
    email: null,
    verifyError: null,
    requestChangeLoading: false,
    verifyOtpLoading: false,
    emailChanged: false,
    otpVerified: false,
    copyUrl: null,
    copyUrlLoading: false,
    successMessage: null,
    bulkInviteLoading: false,
    resendInviteError: null,
    resendSuccess: null,
  },
  reducers: {
    clearVerifyError: (state) => {
      state.verifyError = null;
    },
  },
  extraReducers: (builder) => {
    // Resend Invite
    builder
      .addCase(resendInvite.pending, (state) => {
        state.getLoading = true;
        state.error = null;
      })
      .addCase(resendInvite.fulfilled, (state, action) => {
        state.getLoading = false;
        state.setupUrl = action.payload.setupUrl;
        state.email = action.payload.email;
      })
      .addCase(resendInvite.rejected, (state, action) => {
        state.getLoading = false;
        state.error = action.payload;
      });

    // Request Email Change
    builder
      .addCase(requestEmailChange.pending, (state) => {
        state.requestChangeLoading = true;
        state.error = null;
        state.emailChanged = false;
      })
      .addCase(requestEmailChange.fulfilled, (state, action) => {
        state.requestChangeLoading = false;
        state.successMessage = action.payload.message;
        state.emailChanged = true;
      })
      .addCase(requestEmailChange.rejected, (state, action) => {
        state.requestChangeLoading = false;
        state.error = action.payload;
      });

    // Verify OTP
    builder
      .addCase(verifyEmailChange.pending, (state) => {
        state.verifyOtpLoading = true;
        state.verifyError = null;
        state.otpVerified = false;
      })
      .addCase(verifyEmailChange.fulfilled, (state, action) => {
        state.verifyOtpLoading = false;
        state.successMessage = action.payload.message;
        state.otpVerified = true;
      })
      .addCase(verifyEmailChange.rejected, (state, action) => {
        state.verifyOtpLoading = false;
        state.verifyError = action.payload;
      });
    // Get Copy URL
    builder
      .addCase(getCopyUrl.pending, (state) => {
        state.copyUrlLoading = true;
        state.error = null;
      })
      .addCase(getCopyUrl.fulfilled, (state, action) => {
        state.copyUrlLoading = false;
        state.copyUrl = action.payload;
      })
      .addCase(getCopyUrl.rejected, (state, action) => {
        state.copyUrlLoading = false;
        state.error = action.payload;
      });


  },
});
export const { clearVerifyError } = resendInviteSlice.actions;
export default resendInviteSlice.reducer;
